import { v4 as generateID } from '@lukeed/uuid';
import { setIDs } from '../peaks/util/setIDs';
import { signalsToRanges } from '../signals/signalsToRanges';
import { fetchPrediction } from './utils/fetchPrediction';
import { getFilteredIDiaIDs } from './utils/getFilteredIDiaIDs';
import { isMolfileNotEmpty } from './utils/isMolfileNotEmpty';
import { queryByHose } from './utils/queryByHOSE';
function checkFromPrediction(signal) {
    if (!signal.atoms)
        throw new Error('There is not atoms');
    if (!signal.diaIDs)
        throw new Error('There is not diaIDs');
    if (!signal.nbAtoms)
        throw new Error('There is not nbAtoms');
}
/**
 * Make a query to a hose code based database to predict carbon chemical shift
 * @returns {Promise<object>} - object with molfile, diaIDs, signals, joined signals by diaIDs and ranges.
 */
export async function predictCarbon(options) {
    const { hoses, molfile, database, webserviceURL = 'https://nmr-prediction.service.zakodium.com/v1/predict/carbon', groupedDiaIDs, } = options;
    if (!database && isMolfileNotEmpty(molfile)) {
        return fetchPrediction(molfile, { webserviceURL });
    }
    else if (!isMolfileNotEmpty(molfile)) {
        return {
            nucleus: '13C',
            joinedSignals: [],
            signals: [],
            ranges: [],
        };
    }
    if (!database) {
        throw new Error('There is not a database');
    }
    const maxLevel = database.length - 1;
    let { maxSphereSize = maxLevel } = options;
    if (maxSphereSize > maxLevel)
        maxSphereSize = maxLevel;
    const carbonDiaIDs = getFilteredIDiaIDs({
        groupedDiaIDs,
        hoses,
    });
    const predictions = queryByHose(carbonDiaIDs, database, {
        maxSphereSize,
    });
    const signals = formatSignals(predictions);
    const joinedSignals = joinSignalByDiaID(signals);
    return {
        nucleus: '13C',
        joinedSignals,
        signals,
        ranges: signalsToRanges(joinedSignals),
    };
}
function formatSignals(predictions) {
    const signals = [];
    for (const prediction of predictions) {
        const { atoms, nbAtoms, delta, diaIDs, statistic } = prediction;
        const signal = {
            id: generateID(),
            delta: delta || NaN,
            atoms,
            diaIDs,
            multiplicity: 's',
            nbAtoms,
            statistic,
            js: [],
        };
        signals.push(signal);
    }
    return signals;
}
function joinSignalByDiaID(signals) {
    const joinedSignals = {};
    for (const signal of signals) {
        checkFromPrediction(signal);
        const diaID = signal.diaIDs[0];
        if (!joinedSignals[diaID]) {
            joinedSignals[diaID] = JSON.parse(JSON.stringify(signal));
        }
        else {
            joinedSignals[diaID].nbAtoms += signal.nbAtoms;
            joinedSignals[diaID].atoms.push(...signal.atoms);
        }
    }
    return setIDs(Object.values(joinedSignals));
}
//# sourceMappingURL=predictCarbon.js.map